const StatCard = ({ title, value, isLoading = false, onClick, footnote }) => (
  <div
    className={`bg-white p-4 lg:p-6 rounded-card shadow-hairline border border-ink-100 ${
      onClick ? "cursor-pointer hover:bg-cream-100 transition-colors duration-150 ease-editorial" : ""
    }`}
    onClick={onClick}
  >
    <h3 className="smallcaps text-ink-400 min-h-[2.5em] lg:min-h-0 leading-tight">{title}</h3>
    {isLoading ? (
      <div className="h-8 lg:h-10 w-16 lg:w-20 bg-cream-300 rounded mt-2 animate-pulse"></div>
    ) : (
      <p className="font-display text-2xl lg:text-4xl text-ink-900 mt-2 tabular tracking-display">
        {value}
      </p>
    )}
    {footnote && !isLoading && (
      typeof footnote === "string" ? (
        <p className="smallcaps text-ink-400 mt-2 text-[11px]">{footnote}</p>
      ) : (
        <button
          onClick={(e) => { e.stopPropagation(); footnote.onClick(); }}
          className="mt-2 text-xs text-accent-600 hover:text-accent-700 hover:underline text-left transition-colors"
        >
          {footnote.label}
        </button>
      )
    )}
  </div>
);

export default StatCard;
